"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Highlight_1 = require("./Highlight");
Object.defineProperty(exports, "Highlight", { enumerable: true, get: function () { return Highlight_1.Highlight; } });
//# sourceMappingURL=index.js.map